import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, TextField } from '@mui/material'
import React from 'react'
import PasswordStrength from '../../../components/PasswordStrength'
import { CheckIcon, EyeIcon, EyeOffIcon } from '../../../template/kartera/icons'
import { useMyAccountPasswordModel } from './my-account-password-model'
import type { MyAccountPasswordProps } from './my-account-password-model'

const MyAccountPassword = (props: MyAccountPasswordProps) => {
    const model = useMyAccountPasswordModel(props)
    const { form, change } = model

    const visibilityAdornment = {
        input: {
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton
                        size="small"
                        aria-label={model.showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                        onClick={model.toggleShowPassword}
                        className="text-k-muted-2"
                    >
                        {model.showPassword ? <EyeIcon /> : <EyeOffIcon />}
                    </IconButton>
                </InputAdornment>
            ),
        },
    }

    return (
        <Dialog open={model.open} onClose={model.close} fullWidth maxWidth="xs" slotProps={{ paper: { className: 'k-dialog' } }}>
            <form onSubmit={model.submit}>
                <DialogTitle>Cambiar contraseña</DialogTitle>
                <DialogContent>
                    <div className="flex flex-col gap-5 pt-1">
                        <p className="m-0 text-sm text-k-ink-2">Escribe tu contraseña actual y la nueva contraseña dos veces para confirmarla.</p>
                        <TextField
                            className="v2-field" variant="filled" fullWidth required autoFocus
                            label="Contraseña actual"
                            type={model.inputType}
                            autoComplete="current-password"
                            value={form.oldPassword}
                            onChange={(event) => change.oldPassword(event.target.value)}
                            slotProps={visibilityAdornment}
                        />
                        <TextField
                            className="v2-field" variant="filled" fullWidth required
                            label="Nueva contraseña"
                            type={model.inputType}
                            autoComplete="new-password"
                            helperText={<PasswordStrength password={form.newPassword} />}
                            value={form.newPassword}
                            onChange={(event) => change.newPassword(event.target.value)}
                            slotProps={visibilityAdornment}
                        />
                        <TextField
                            className="v2-field" variant="filled" fullWidth required
                            label="Repite la nueva contraseña"
                            type={model.inputType}
                            autoComplete="new-password"
                            value={form.newPassword2}
                            onChange={(event) => change.newPassword2(event.target.value)}
                            slotProps={visibilityAdornment}
                        />
                        {model.message && (
                            <div className={`flex items-center gap-3 rounded-[14px] px-4 py-3.5 text-sm ${model.message.type === 'error' ? 'bg-k-danger-soft text-k-danger-ink' : 'bg-k-ok-soft text-k-ok'}`}>
                                <ErrorOutlineIcon style={{ fontSize: 20 }} />
                                <p className="m-0">{model.message.message}</p>
                            </div>
                        )}
                    </div>
                </DialogContent>
                <DialogActions className="gap-1 px-6 pb-5">
                    <button
                        type="button"
                        className="inline-flex h-11 items-center gap-2 rounded-xl border border-k-line bg-k-surface px-4 text-sm font-semibold text-k-ink hover:bg-k-hover"
                        onClick={model.close}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        disabled={model.saving}
                        className="inline-flex h-11 items-center gap-2 rounded-xl bg-k-primary px-[18px] text-sm font-bold !text-white hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-40"
                    >
                        <CheckIcon />
                        {model.saving ? 'Guardando…' : 'Cambiar contraseña'}
                    </button>
                </DialogActions>
            </form>
        </Dialog>
    )
}

export default MyAccountPassword
